import { Root, TabsContent, TabsProps } from '@radix-ui/react-tabs';

import { CommonTabProps } from '../../types';

import { List } from './List';
import { Trigger } from './Trigger';

interface CapsuleProps extends Omit<TabsProps, 'onChange' | 'onValueChange' | 'content'>, CommonTabProps {}

function Capsule({ index, value, data, content, onChange, disabled, ...props }: CapsuleProps) {
  const currentValue = value ?? (index !== undefined ? data[index]?.key ?? data[index]?.value : undefined);

  return (
    <Root value={currentValue} onValueChange={onChange} {...props}>
      <List className="mb-5">
        {data.map((d) => {
          const _disabled = disabled ?? (typeof d.disabled === 'function' ? d.disabled(currentValue) : d.disabled);

          return (
            <Trigger key={d.key ?? d.value} value={d.key ?? d.value} disabled={_disabled}>
              {d.title || d.value}
            </Trigger>
          );
        })}
      </List>
      {data.map((d) => (
        <TabsContent role="tabpanel" key={d.key ?? d.value} value={d.key ?? d.value}>
          {d.content ?? content}
        </TabsContent>
      ))}
    </Root>
  );
}

Capsule.Root = Root;
Capsule.List = List;
Capsule.Trigger = Trigger;
Capsule.Content = TabsContent;

export { Capsule };
